import { getRefernceDataByType } from "@services/referenceDataApi";
import { useQuery } from "@tanstack/react-query";

const toOptionsArray = <T>(data: unknown): T[] => {
  if (Array.isArray(data)) return data as T[];
  if (data && typeof data === "object") return Object.values(data as Record<string, T>);
  return [];
};

type UseFormattedReferenceOptions = {
  enabled?: boolean;
};

export const useFormattedReference = <T = unknown>(
  key: string,
  service: string,
  options?: UseFormattedReferenceOptions,
) => {
  const { data = [], isLoading } = useQuery<T[]>({
    queryKey: [key, service],
    queryFn: () => getRefernceDataByType(key, service) as Promise<T[]>,
    staleTime: Infinity, // never consider data “stale”
    refetchOnWindowFocus: false,
    enabled: options?.enabled ?? true,
  });

  return { options: toOptionsArray<T>(data), isLoading };
};
